module.exports = __webpack_public_path__ + "media/login.b990b984.mp4";